import React, { Component } from 'react'
import Predefine_PoloNack_Soccer from '../components/Predefine_PoloNack_Soccer/Predefine_PoloNack_Soccer'

export class Predefine_PoloNack_SoccerPage extends Component {
  render() {
    return (
      <Predefine_PoloNack_Soccer/>
    )
  }
}

export default Predefine_PoloNack_SoccerPage